import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function BackgroundFileTable({ backgroundFiles, onEdit, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Filename</th>
                <th>File Path</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {backgroundFiles.map(backgroundFile => (
                <BackgroundFileRow backgroundFile={backgroundFile} key={backgroundFile.id} onEdit={onEdit} onDelete={onDelete} />
            ))}
            </tbody>
        </table>
    );
}

function BackgroundFileRow({ backgroundFile, onEdit, onDelete }) {
    return (
        <tr>
            <td>{backgroundFile.id}</td>
            <td>{backgroundFile.name}</td>
            <td>{backgroundFile.filePath}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(backgroundFile)} />
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(backgroundFile.id)} />
            </td>
        </tr>
    );
}

export default BackgroundFileTable;
